<template>
    <van-popup v-model:show="show" position="bottom" :style="{
        minWidth: '100%',
        minHeight: '100vh',
        zIndex: '10002'
    }">
        <div class="pop_container">
            <div class="close_icon"> <img src="@/assets/loginRegister/close_icon.png" alt="" @click="close"></div>
            <div class="register_container">

                <div class="form_container">
                    <div class="main_title">{{ signType == 0 ? $t('common.register') : $t('common.login') }}</div>

                    <div v-if="signType == 0" class="content_text">{{ $t('loginRegister.alreadyAcc') }}
                        <span @click="changeSignType(1)">{{ $t('loginRegister.loginNow') }}</span>
                    </div>
                    <div v-if="signType == 1" class="content_text">{{ $t('loginRegister.dontHaveAcc') }}
                        <span @click="changeSignType(0)">{{ $t('loginRegister.registerNow') }}</span>
                    </div>

                    <InputField v-model="phoneNumber" :isShowError="phoneValidationNotice"
                        @valueChanged="phoneNumberChange" :labelText="$t('profile.phoneNum')" :isshowFlag="true"
                        fieldType="number" />
                    <div>
                        <div v-if="phoneValidationNotice" class="errorNotice">
                            {{ $t('loginRegister.phoneFormat') }}
                        </div>
                    </div>

                    <InputField v-model="password" :isShowError="passwordValidationNotice"
                        @valueChanged="passwordChange" :isPassword="true" :labelText="$t('loginRegister.enterPassword')" 
                        fieldType="password" />
                    <div v-if="passwordValidationNotice" class="errorNotice">
                        {{ $t('loginRegister.passwordForamt') }}
                    </div>
                    <InputField v-if="signType == 0" v-model="confirmPassword"
                        :isShowError="confirmPasswordValidationNotice || (password !== '' && confirmPassword !== '' && password !== confirmPassword)"
                        @valueChanged="confirmPasswordChange" :isPassword="true" :labelText="$t('loginRegister.confirmPassword')"
                        fieldType="password" />
                    <div v-if="confirmPasswordValidationNotice" class="errorNotice">
                        {{ $t('loginRegister.passwordForamt') }}
                    </div>
                    <div v-else-if="confirmPassword && password && confirmPassword !== password" class="errorNotice">
                        {{ $t('loginRegister.differentPassword') }}
                    </div>


                    <div v-if="signType == 0 && false" class="human_verify">
                        <iframe
                            src="https://challenges.cloudflare.com/cdn-cgi/challenge-platform/h/g/turnstile/if/ov2/av0/rcv/374p4/0x4AAAAAAA_CgXp5DcwwFYjj/light/fbE/auto_timeout/normal/auto/"
                            allow="cross-origin-isolated; fullscreen; autoplay"
                            sandbox="allow-same-origin allow-scripts allow-popups" id="cf-chl-widget-374p4" tabindex="0"
                            title="Widget containing a Cloudflare security challenge"
                            style="border: none; overflow: hidden; width: 300px; height: 65px;"></iframe>
                    </div>

                    <div class="btn_container">
                        <MainButton v-if="signType == 0" :title="$t('common.register')" :activeStatus="isRegisterBtnActive" @click="signUp" />
                        <MainButton v-if="signType == 1" :title="$t('common.login')" :activeStatus="isLoginBtnActive"
                            @click="signIn(false)" />
                    </div>

                </div>

            </div>
        </div>


    </van-popup>
    <StatusPopup ref="statusRef" :is-show-success="isSuccess" :content="toastContent" />
    <LoadingScreen ref="loadingRef" />
</template>

<script setup lang="ts">
import { ref, defineExpose, computed, onBeforeMount } from 'vue';
import InputField from './components/inputField.vue';
import MainButton from '@/components/common/mainButton.vue';
import StatusPopup from '@/components/common/statusPopup.vue';
import { v4 as uuidv4 } from 'uuid';
import { login, register } from '@/api/user';
import { useUserStore } from '@/stores/user';
import LoadingScreen from '@/components/common/loadingScreen.vue';
import { initSSE } from '@/utils/sse';
import { useGameStore } from '@/stores/games';

const userStore = useUserStore()
const gameStore = useGameStore()
const phoneNumber = ref('')
const password = ref('')
const confirmPassword = ref('')
const agentKey = ref('')
const phoneValidationNotice = ref(false)
const passwordValidationNotice = ref(false)
const confirmPasswordValidationNotice = ref(false)
const show = ref(false)
const signType = ref(0)
const statusRef = ref()
const isSuccess = ref(false)
const toastContent = ref('')
const loadingRef = ref()
const isPWA = ref(false);
const open = (type: number) => {
    show.value = true
    signType.value = type
}

const close = () => {
    show.value = false
}

const changeSignType = (value: number) => {
    signType.value = value
}

const phoneNumberChange = (value: string) => {
    phoneNumber.value = value
    checkPhoneValidation(value)
}

const passwordChange = (value: string) => {
    password.value = value
    checkPasswordValidation(value)
}

const confirmPasswordChange = (value: string) => {
    confirmPassword.value = value
    checkConfirmPasswordValidation(value)
}

const isRegisterBtnActive = computed(() => {
  if (signType.value === 0) {
    return (
      phoneNumber.value.length > 0 &&
      password.value.length > 0 &&
      confirmPassword.value.length > 0 &&
      !phoneValidationNotice.value &&
      !passwordValidationNotice.value &&
      !confirmPasswordValidationNotice.value
    );
  }
  return false;
});
const isLoginBtnActive = computed(() => {
  if (signType.value === 1) {
    return (
      phoneNumber.value.length > 0 &&
      password.value.length > 0 &&
      !phoneValidationNotice.value &&
      !passwordValidationNotice.value
    );
  }
  return false;
});
const checkPhoneValidation = (value: any) => {
    if (value.length == 11 && value[2] == '9' || value.length == 0) {

        phoneValidationNotice.value = false
    } else {
        phoneValidationNotice.value = true
    }
}
const checkPasswordValidation = (value: any) => {
    if (value.length >= 8 && value.length <= 20 || value.length == 0) {
        passwordValidationNotice.value = false
    } else {
        passwordValidationNotice.value = true
    }
}
const checkConfirmPasswordValidation = (value: any) => {
    if (value.length >= 8 && value.length <= 20 || value.length == 0) {
        confirmPasswordValidationNotice.value = false
    } else {
        confirmPasswordValidationNotice.value = true
    }
}
const showError = (message: string) => {
    toastContent.value = message;
    isSuccess.value = false;
    statusRef.value.open()
}
const showSuccess = (message: string) => {
    toastContent.value = message;
    isSuccess.value = true;
    statusRef.value.open()
}
const signIn = (isReg:boolean) => {
    if(!isReg) {
        loadingRef.value.open();
    }
    const params = {
        username: phoneNumber.value,
        code: "2",
        grantType: "password",
        password: password.value,
        rememberMe: false,
        tenantId: process.env.VUE_APP_TENANT_ID,
        clientId: process.env.VUE_APP_CLIENT_ID,
        uuid: ""
    }
    login(params).then(res => {
        loadingRef.value.close()
        setTimeout(() => {
            if(!isReg) {
                showSuccess(res.msg);
            }
            show.value = false;
        }, 500)
        localStorage.setItem('token', res.data.access_token);
        initSSE(process.env.VUE_APP_BASE_API + '/app/resource/sse');
        gameStore.getGameGroupListData()
        if(isPWA.value) {
            userStore.getInfo();
            userStore.getPWARewardAPI();
        } else {
            userStore.getInfo();
        }
    }).catch(err => {
        loadingRef.value.close()
        showError(err);
    })
}
const signUp = () => {
    loadingRef.value.open()
    const params = new URLSearchParams(window.location.hash.split('?')[1] || '')
    agentKey.value = params.get('ref') || ''
    const data = {
        username: phoneNumber.value,
        password: password.value,
        userType: "app_user",
        registerType: "mobile",
        agentKey: agentKey.value,
        isApp: 1,
        isPwa: 0,
        isApk: 0,
        grantType: "password",
        tenantId: process.env.VUE_APP_TENANT_ID,
        clientId: process.env.VUE_APP_CLIENT_ID
    }
    register(data).then(res => {
        loadingRef.value.close()
         setTimeout(() => {
            showSuccess(res.msg);
            signIn(true)
            // signType.value = 1;
        }, 500)
    }).catch(err => {
        loadingRef.value.close()
        showError(err);
    })
}

onBeforeMount(()=>{
    isPWA.value = window.matchMedia('(display-mode: standalone)').matches ||
        (window.navigator.standalone === true) ||
        document.referrer.includes('android-app://');
})

defineExpose({
    open,
    close
})
</script>
<style scoped>
.pop_container {
    background: url('@/assets/loginRegister/homev2_Login_bg.png');
    background-size: cover;
    background-repeat: no-repeat;
    width: 100%;
    height: 100vh;
}

.register_container {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    height: 85%;
}

.form_container {
    background-image: linear-gradient(180deg, rgba(136, 90, 41, 0.50) 0%, rgba(40, 18, 3, 0.50) 100%);
    box-shadow: inset 0px -2px 0px 0px rgba(225, 146, 90, 1), inset 0px 2px 0px 0px rgba(225, 146, 90, 1);
    backdrop-filter: blur(4px) !important;
    margin: 70px 0;
    border-radius: 20px;
    padding: 20px;
    width: 80%;
}

.close_icon {
    display: flex;
    justify-content: right;
    padding: 20px 15px;
}

.close_icon img {
    width: 18px;
    padding: 2.5px;
    background: rgba(0, 0, 0, 0.25);
    border-radius: 30px;
}

.main_title {
    font-weight: bold;
    font-size: 35px;
    color: #FFFFFF;
    padding: 15px 0;
}

.content_text {
    font-weight: 600;
    font-size: 13px;
    color: #FFFFFF;
    padding: 0 0 15px;
}

.content_text span {
    color: #FF780D;
}

.human_verify {
    margin: 10px;
    /* background-color: #fff;
    padding: 35px;
    margin: 10px 0 0; */
}

.errorNotice {
    color: #E00000;
    font-size: 15px;
    padding: 0 10px;
}

.btn_container {
    padding-top: 25px;
}
</style>